const AppointmentCancellationReason = {
  CUSTOMER_NOT_INTERESTED: 'CUSTOMER_NOT_INTERESTED',
  OTHER: 'OTHER',
  TECH_SETUP_NOT_REACHED: 'TECH_SETUP_NOT_REACHED',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET: 'TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT: 'TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT',
  TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED: 'TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED',
  SYSTEM_ROLLBACK: 'SYSTEM_ROLLBACK',
  SYSTEM_OUTAGE: 'SYSTEM_OUTAGE',
  // Network (NETWORK, NETWORK_HOME_DELIVERY) primary reasons
  NOT_MOVING_FORWARD: 'NOT_MOVING_FORWARD',
  COST_INSURANCE: 'COST_INSURANCE',
  PERSONAL_HEALTH: 'PERSONAL_HEALTH',
  TRAVEL_TRANSPORTATION: 'TRAVEL_TRANSPORTATION',
  CLINIC_CANCELLED: 'CLINIC_CANCELLED',
  // Germany (DE) primary reasons
  CUSTOMER: 'CUSTOMER',
  PARTNER: 'PARTNER',
  TECH: 'TECH',
  TECH_SETUP_INCOMPLETE: 'TECH_SETUP_INCOMPLETE',
} as const

type AppointmentCancellationReason = (typeof AppointmentCancellationReason)[keyof typeof AppointmentCancellationReason]

type SystemAppointmentCancellationReason =
  | typeof AppointmentCancellationReason.SYSTEM_ROLLBACK
  | typeof AppointmentCancellationReason.SYSTEM_OUTAGE

type HumanAppointmentCancellationReason = Exclude<
  (typeof AppointmentCancellationReason)[keyof typeof AppointmentCancellationReason],
  SystemAppointmentCancellationReason
>

const HumanAppointmentCancellationReason: Record<HumanAppointmentCancellationReason, HumanAppointmentCancellationReason> = {
  CUSTOMER_NOT_INTERESTED: 'CUSTOMER_NOT_INTERESTED',
  OTHER: 'OTHER',
  NOT_MOVING_FORWARD: 'NOT_MOVING_FORWARD',
  COST_INSURANCE: 'COST_INSURANCE',
  PERSONAL_HEALTH: 'PERSONAL_HEALTH',
  TRAVEL_TRANSPORTATION: 'TRAVEL_TRANSPORTATION',
  CLINIC_CANCELLED: 'CLINIC_CANCELLED',
  CUSTOMER: 'CUSTOMER',
  PARTNER: 'PARTNER',
  TECH: 'TECH',
  TECH_SETUP_NOT_REACHED: 'TECH_SETUP_NOT_REACHED',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET: 'TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT: 'TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT',
  TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED: 'TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED',
  TECH_SETUP_INCOMPLETE: 'TECH_SETUP_INCOMPLETE',
} as const

export type { SystemAppointmentCancellationReason }
export { AppointmentCancellationReason, HumanAppointmentCancellationReason }
